import { get } from '../../../redux/api';
import { useQuery } from '../../../ReactQuery';
import type { SharedOrganizationsResponse } from '../../../../shared/types/routes/sbomShare';

/**
 * Function to fetch all shared organizations
 */
function fetchSharedOrganizations() {
  return get<SharedOrganizationsResponse>('/api/v1/shared-organizations');
}

/**
 * Query key for caching and invalidation
 */
export const getSharedOrganizationsQueryKey = () => ['sbomShare', 'sharedOrganizations'];

/**
 * Hook to fetch all organizations available for sharing and shared with us
 */
export default function useGetSharedOrganizations() {
  return useQuery<SharedOrganizationsResponse>({
    queryKey: getSharedOrganizationsQueryKey(),
    queryFn: fetchSharedOrganizations,
  });
}
